import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/views/Home/index.vue'
import hyzz from '@/views/Hyzz/index.vue'
import gyhy from '@/views/Gyhy/index.vue'
import lxhy from '@/views/Lxhy/index.vue'
import cgal from '@/views/Cgal/index.vue'
import hyjz from '@/views/Hyjz/index.vue'
import hycz from '@/views/Hycz/index.vue'
import hyxny from '@/views/Hyxny/index.vue'
import homeen from '@/views/Home_en/index.vue'
import hyzzen from '@/views/Hyzz_en/index.vue'
import gyhyen from '@/views/Gyhy_en/index.vue'
import lxhyen from '@/views/Lxhy_en/index.vue'
import cgalen from '@/views/Cgal_en/index.vue'
import hyjzen from '@/views/Hyjz_en/index.vue'
import hyczen from '@/views/Hycz_en/index.vue'
import hyxnyen from '@/views/Hyxny_en/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path:'/',
    redirect:'/homeen'
  },
  {
    path:'/hyzz',
    name:'hyzz',
    component:hyzz
  },
  {
    path:'/gyhy',
    name:'gyhy',
    component:gyhy
  },
  {
    path:'/lxhy',
    name:'lxhy',
    component:lxhy
  },
  {
    path:'/cgal',
    name:'cgal',
    component:cgal
  },
  {
    path:'/hyjz',
    name:'hyjz',
    component:hyjz
  },
  {
    path:'/hycz',
    name:'hycz',
    component:hycz
  },
  {
    path:'/hyxny',
    name:'hyxny',
    component:hyxny
  },
  {
    path: '/homeen',
    name: 'homeen',
    component: homeen
  },
  {
    path:'/hyzzen',
    name:'hyzzen',
    component:hyzzen
  },
  {
    path:'/gyhyen',
    name:'gyhyen',
    component:gyhyen
  },
  {
    path:'/lxhyen',
    name:'lxhyen',
    component:lxhyen
  },
  {
    path:'/cgalen',
    name:'cgalen',
    component:cgalen
  },
  {
    path:'/hyjzen',
    name:'hyjzen',
    component:hyjzen
  },
  {
    path:'/hyczen',
    name:'hyczen',
    component:hyczen
  },
  {
    path:'/hyxnyen',
    name:'hyxnyen',
    component:hyxnyen
  },
  {
    path: '*',
    redirect:'/homeen'
  }
]

const router = new VueRouter({
  mode: 'history', // 添加这一行
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; 
    }
    return { x: 0, y: 0 };
  } 
})

export default router
